import axios from 'axios';

const saveTags = ({ userIds, selectedTags, remove }) =>
  axios.post('/users/save_tags', {
    remove,
    user_ids: userIds,
    selected_tags: selectedTags,
  });
const changeLoginMethod = ({ uid, username, redirect }) =>
  axios.post('/users/change_login_method', {
    uid,
    username,
    redirect,
  });
const downloadUserDocument = ({ link }) =>
  axios.post('/users/download_user_document', {
    link,
  });
const getLinkedAccounts = () => axios.get('/users/get_linked_accounts');
const linkAccount = ({
  provider,
  code,
  microsoftPermissionsUsageCategory,
  redirectUri,
}) =>
  axios.post('/users/link_account', {
    provider,
    code,
    microsoft_permissions_usage_category: microsoftPermissionsUsageCategory,
    redirect_uri: redirectUri,
  });

const unlinkAccount = ({ email, provider }) =>
  axios.post('/users/unlink_account', {
    email,
    provider,
  });
const setPassword = ({ newPassword }) =>
  axios.post('/users/set_password', {
    new_password: newPassword,
  });
const forceSetPassword = ({ newPassword }) =>
  axios.post('/users/force_set_password', {
    new_password: newPassword,
  });
const setSignInMethod = ({ signInMethod, newPassword, phoneNumber, email }) =>
  axios.post('/users/set_sign_in_method', {
    sign_in_method: signInMethod,
    new_password: newPassword,
    phone_number: phoneNumber,
    email: email,
  });
const getUserGroup = id => axios.get(`users/${id}/group`);
const join = user => axios.post('/users/join', user);
const sendIdentityVerificationSms = () =>
  axios.post('/users/send_identity_verification_sms');
const checkIdentityBySms = code =>
  axios.post('/users/check_identity_by_sms', {
    code,
  });
const updateTags = ({ userId, contactTags }) =>
  axios.post('/users/update_tags', {
    user_id: userId,
    contact_tags: contactTags,
  });
const createFirm = ({ fname, lname, email, firmName }) =>
  axios.post('/resources/create_firm', {
    email,
    fname,
    lname,
    firm_name: firmName,
  });
const saveOverviewSetting = overviewSetting =>
  axios.post('/users/update_overview_setting', overviewSetting);
const book = ({ email, phoneNumber, businessName, businessActivity }) =>
  axios.post('/users/book', {
    email,
    phone_number: phoneNumber,
    business_name: businessName,
    business_activity: businessActivity,
  });
const updateUser = ({ id, ...rest }) =>
  axios.patch(`/users/${id}`, {
    ...rest,
  });
const registerFirebase = user => axios.post('/users/register_firebase', user);
const log = logData => axios.post('/log', logData);
const startStripeSession = ({ userId }) =>
  axios.post('/sessions/start_stripe_session', {
    user_id: userId,
  });
const updateCard = ({ sessionId }) =>
  axios.post('/sessions/update_card', {
    session_id: sessionId,
  });
const getAllPaymentMethods = ({ userId }) =>
  axios.post('/sessions/get_all_payment_methods', {
    user_id: userId,
  });
const setPrimaryMethod = ({ userId, paymentMethodId }) =>
  axios.get('/sessions/set_primary_method', {
    user_id: userId,
    payment_method: paymentMethodId,
  });
const deleteClientFromAPI = id =>
  axios.post('/users/delete_client_from_api', {
    id,
  });

const findUserByEmail = email =>
  axios.get('/users/find_user_by_email', { params: { email } });

const createClientWithAPI = ({
  email,
  firstName,
  lastName,
  phoneNumber,
  preferredName,
  workPhoneNumber,
  workPhoneExtension,
  businessEmail,
  otherEmail,
  entityType,
  companyName,
  street,
  city,
  state,
  zip,
  country,
  preferredContactMethod,
  passwordless,
  taxSoftware,
  groupId,
  forTesting,
  useTempEmail,
  timeZone,
  externalEntityId,
  externalUserId,
  advisorId,
  taxReturnId,
  spouseSSN,
}) =>
  axios.post('/users/create_client_from_api', {
    email,
    street,
    city,
    state,
    zip,
    country,
    entity_type: entityType,
    time_zone: timeZone,
    preferred_name: preferredName,
    phone_number: phoneNumber,
    work_phone_number: workPhoneNumber,
    work_phone_extension: workPhoneExtension,
    business_email: businessEmail,
    other_email: otherEmail,
    fname: firstName,
    lname: lastName,
    company_name: companyName,
    preferred_contact_method: preferredContactMethod,
    passwordless: passwordless,
    tax_software: taxSoftware,
    firm_group_id: groupId,
    for_testing: forTesting,
    generate_temp_email: useTempEmail,
    external_entity_id: externalEntityId,
    external_user_id: externalUserId,
    assigned_advisor_id: advisorId,
    tax_return_id: taxReturnId,
    spouse_ssn: spouseSSN,
  });

const updateProfilePic = params =>
  axios.post('/users/update_profile_pic', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export default {
  getLinkedAccounts,
  linkAccount,
  unlinkAccount,
  setPassword,
  setSignInMethod,
  forceSetPassword,
  findUserByEmail,
  getUserGroup,
  join,
  book,
  sendIdentityVerificationSms,
  checkIdentityBySms,
  registerFirebase,
  log,
  updateUser,
  startStripeSession,
  updateCard,
  getAllPaymentMethods,
  setPrimaryMethod,
  createClientWithAPI,
  deleteClientFromAPI,
  createFirm,
  saveOverviewSetting,
  updateTags,
  updateProfilePic,
  saveTags,
  changeLoginMethod,
  downloadUserDocument,
};
